import { z } from 'zod';
// ---------------------------------------------------------------------------
// 대량 메시지 생성 스키마
// ---------------------------------------------------------------------------
export const CreateMessageSchema = z.object({
    channel: z.enum(['sms', 'lms', 'kakao'], {
        errorMap: () => ({ message: '유효한 발송 채널이 아닙니다' }),
    }),
    target: z.enum(['all', 'users', 'managers', 'active', 'pending'], {
        errorMap: () => ({ message: '유효한 대상이 아닙니다' }),
    }),
    content: z.string().min(1, '메시지 본문을 입력하세요'),
    senderNumber: z.string().min(1, '발신 번호를 입력하세요'),
    scheduledAt: z.string().datetime().nullable().optional(),
});
//# sourceMappingURL=message.js.map